(async () => {
    const { Core } = await importModule('Core');
    const { $clone } = await importModule('Utils');

    const SEL_INPUT = '[data-input]';

    customElements.define('product-qty-selector', class extends Core {
        elements = {
            selector: '[data-selector-wrapper]',
            inputTemplate: '[data-input-template]'
        }
        render() {
            this.$selector.addEventListener('change', this._onQtyChange.bind(this))
        }
        _onQtyChange(e) {
            if (+e.target.value === 10) this._changeInputType();
        }
        _changeInputType() {
            this.replaceChild($clone(this.$inputTemplate), this.$selector);
            this.querySelector(SEL_INPUT).setAttribute('value', 10);
        }        
    })
})();


// Product Page - quantity up/down button from Cheadle

// $('.quantity-box .quantity-button').on('click', function(){
//   console.log('here');
//   var qty = parseInt($(this).parent('.quantity-box').find('.quantity-input').val());
//   if($(this).hasClass('quantity-plus')) 
//   {
//     qty++;
//   }
//   else
//   {
//     if(qty > 1) {
//       qty--;
//     }
//   }
//   qty = (isNaN(qty))?1:qty;
//   $(this).parent('.quantity-box').find('.quantity-input').val(qty);
// });




// Javascript for quantity up/down button

// listen for the click on the quantity buttons
var quantityButtons = document.querySelectorAll('.quantity-box .quantity-button');

quantityButtons.forEach(function(button) {
  button.addEventListener("click", function() {

  // create the variable for quantity
    var qty = parseInt(document.querySelector('.quantity-input').value);
    
    // if + button, add one else if - button, take away
      if (button.classList.contains("quantity-plus")) {
        qty++;
      } else {
          if (qty > 1) {
            qty--;
          }
      }
    
    // check if NaN
      if (isNaN(qty)) {
        qty = 1;
      }
        else {
        qty = qty;
      }
    document.querySelector('.quantity-input').value = qty;                                                        
  });
});